// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-container {
    display: flex;
    flex-direction: column;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
  
 mat-card div > * {
    width: 100%;
    text-align: center;
  }

  .green{
      background-color: green;
      color: white;
      font-size: 25px;
  }

  .warning{
    background-color: yellow;
    color: black;
    font-size: 25px;
}

.danger{
    background-color: red;
    color: white;
    font-size: 20px;
}

.blue{
    background-color: #005776;
    color: white;
    font-size: 20px;
}

.tempcheck{
    background-color:#ff8c00;
    color: white;
    font-size: 25px;
}



  @media(max-width:762px){
      .example-container{
          width: 100%;
      }
  }

  .button {
    position: relative;
    text-decoration: none;
    padding: 4px;
    padding-left: 12px;
    padding-right: 12px;
    border-radius: 4px;
    /* margin-top: 100px; */
    display: inline-block;
    float: right;
}


/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/covid-exposure/exposure-report.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;;CAED;IACG,WAAW;IACX,kBAAkB;EACpB;;EAEA;MACI,uBAAuB;MACvB,YAAY;MACZ,eAAe;EACnB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,eAAe;AACnB;;;;EAIE;MACI;UACI,WAAW;MACf;EACJ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IAGnB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;;AACA,o7EAAo7E","sourcesContent":[".example-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 80%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n mat-card div > * {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n\r\n  .green{\r\n      background-color: green;\r\n      color: white;\r\n      font-size: 25px;\r\n  }\r\n\r\n  .warning{\r\n    background-color: yellow;\r\n    color: black;\r\n    font-size: 25px;\r\n}\r\n\r\n.danger{\r\n    background-color: red;\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.blue{\r\n    background-color: #005776;\r\n    color: white;\r\n    font-size: 20px;\r\n}\r\n\r\n.tempcheck{\r\n    background-color:#ff8c00;\r\n    color: white;\r\n    font-size: 25px;\r\n}\r\n\r\n\r\n\r\n  @media(max-width:762px){\r\n      .example-container{\r\n          width: 100%;\r\n      }\r\n  }\r\n\r\n  .button {\r\n    position: relative;\r\n    text-decoration: none;\r\n    padding: 4px;\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    -webkit-border-radius: 4px;\r\n    -moz-border-radius: 4px;\r\n    border-radius: 4px;\r\n    /* margin-top: 100px; */\r\n    display: inline-block;\r\n    float: right;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
